import {Status, Wrapper} from '@googlemaps/react-wrapper';
import {FC, useCallback, useEffect, useState} from 'react';
import {defaultMapCenter} from 'src/utils/consts';
import {Map} from '../Map';
import {MapMarker} from '../Map/Map.types';
import {MapWrapperType} from './MapWrapper.types';

const render = (status: Status) => {
    return <h1>{status}</h1>;
};

export const MapWrapper: FC<MapWrapperType> = ({
                                                   markers,
                                                   zoom,
                                                   mapCenter = defaultMapCenter,
                                                   clusterization,
                                                   handleClick,
                                               }) => {
    const [marks, setMarks] = useState<MapMarker[]>();

    // Held steady between renders on purpose: Map keys its click listener on this function, and an
    // inline one made that effect run on every render - which is what kept rebuilding the map's
    // markers underneath it.
    const onClick = useCallback((e: google.maps.MapMouseEvent) => {
        if (e.latLng && handleClick) {
            const place = {
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
            };
            handleClick(e);
            setMarks([place]);
        }
    }, [handleClick]);

    // The centre becomes the pin only where no pins are given - the location form, which places one
    // where the address resolves. A page passing its own pins keeps them: a new centre object each
    // render used to replace a named pin with a bare one, and the pin went mute after any re-render.
    useEffect(() => {
        if (markers) {
            return;
        }
        if (mapCenter.lat !== defaultMapCenter.lat || mapCenter.lng !== defaultMapCenter.lng) {
            setMarks([mapCenter]);
        }
    }, [mapCenter, markers]);

    useEffect(() => {
        setMarks(markers);
    }, [markers]);

    return (
        <>
            {process.env.REACT_APP_GOOGLE_API_KEY && (
                <Wrapper
                    apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                    render={render}
                >
                    <Map
                        center={mapCenter}
                        onClick={onClick}
                        zoom={zoom}
                        style={{flexGrow: '1', height: '100%'}}
                        fullscreenControl={false}
                        panControl={false}
                        zoomControl={false}
                        mapTypeControl={false}
                        streetViewControl={false}
                        // Google's own place icons stay decoration. Clickable, they opened Google's
                        // card for a shop or a café - one that often fails to load - on top of our
                        // pins, and a click meant for the map went to it instead.
                        clickableIcons={false}
                        markers={marks}
                        clusterization={clusterization}
                    />
                </Wrapper>
            )}
        </>
    );
};
